import flattenObject from './flattenObject';

const objectSummary = (object, maxLength = 100) => {
	if (typeof object === 'object') {
		const flatObject = flattenObject(object);
		const kvp = []; // key value pairs
		Object.keys(flatObject).forEach((key) => {
			kvp.push(`${key} = ${objectSummary(flatObject[key])}`);
		});
		return kvp.join(', ').substring(0, maxLength);
	} else {
		return `${object}`.substring(0, maxLength);
	}
};
export default objectSummary;
